import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdministradorGestionRoutingModule } from './administrador-gestion-routing.module';
import { CatalogosComponent } from './catalogos/catalogos.component';
import { SharedModule } from '../../shared/shared.module';
import { AltaPlanesComponent } from './alta-planes/alta-planes.component';


@NgModule({
  declarations: [
    CatalogosComponent,
    AltaPlanesComponent
  ],
  imports: [
    CommonModule,
    AdministradorGestionRoutingModule,
    SharedModule
  ]
})
export class AdministradorGestionModule { }
